import styled from 'styled-components';

export const Tooltip = styled.div`
  position: absolute;
  top: 100%;


  &:after,
  &:before {
    -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=0)';
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=0);
    -webkit-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,
      -webkit-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
    -moz-transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,
      -moz-transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
    transition: opacity 0.2s ease-in-out, visibility 0.2s ease-in-out,
      transform 0.2s cubic-bezier(0.71, 1.7, 0.77, 1.24);
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
    pointer-events: none;
  }

  &:before {
    z-index: 1001;
    border: 6px solid transparent;
    background: transparent;
    content: '';
  }

  &:focus:before,
  &:focus:after {
    visibility: visible;
    -ms-filter: 'progid:DXImageTransform.Microsoft.Alpha(Opacity=100)';
    filter: progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity: 1;
    -webkit-transform: translateY(-12px);
    -moz-transform: translateY(-12px);
    transform: translateY(-12px);
  }

  &:after {
    z-index: 1000;
    padding: 2px 4px;
    width: 100px;
    color: #f11a48;
    content: attr(data-tooltip);
    white-space: pre-wrap;
    font-size: 12px;
    text-align: center ;
    line-height: 1.2;
  }

  &:before,
  &:after {
    bottom: 100%;
    transform: translate(-95%, 100%);
  }


`;

export const TooltipError = styled(Tooltip)`
  &:after{
    color: #f11a48;
    width: max-content;
    content: ${(props) => `"${props.$content}"`};
    font-weight: bold;
    margin-left: ${(props) => (props.$type === 'tel' ? '56px' : '-12px')};
  }
`;
